import { render } from "./TransfaresPage.vue?vue&type=template&id=5f0877be&scoped=true"
import script from "./TransfaresPage.vue?vue&type=script&lang=js"
export * from "./TransfaresPage.vue?vue&type=script&lang=js"

import "./TransfaresPage.vue?vue&type=style&index=0&id=5f0877be&scoped=true&lang=css"

import exportComponent from "F:\\omar pos 2\\pos_administration_platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f0877be"]])

export default __exports__